import { render } from "./FaceGridIntroPage.vue?vue&type=template&id=894a4e46&scoped=true"
import script from "./FaceGridIntroPage.vue?vue&type=script&lang=js"
export * from "./FaceGridIntroPage.vue?vue&type=script&lang=js"

import "./FaceGridIntroPage.vue?vue&type=style&index=0&id=894a4e46&scoped=true&lang=css"

import exportComponent from "/Users/daiabromberg/Downloads/Parsons_Spring/MS2/msdv-thesis/Project/vue-app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-894a4e46"]])

export default __exports__